var link = '_14d74zf0';

export { link };
//# sourceMappingURL=link.css.js.map
